/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useState } from 'react'
import { useGLTF, Html } from '@react-three/drei'
import { useDrag } from '@use-gesture/react'
import { useSpring, a } from '@react-spring/three'

import { PLANE_COLOR, HOVER_COLOR, MATERIAL_COLOR } from '../Scene'

const SLIDER_MIN = -0.05
const SLIDER_MAX = 1.05

export default function Model({
	enableSelection,
	isSelected,
	onSelect,
	onUseDrag,
	showHhtml = false,
	...props
}) {
	const group = useRef()
	const { nodes } = useGLTF('/Slider_TP1.gltf')
	const [absoluteValue, setAbsoluteValue] = useState(0)
	const [baseHover, setBaseHover] = useState(false)

	const [spring, set] = useSpring(() => ({
		position: [-0.05, 0.01, 0]
		//config: { mass: 1, friction: 10, tension: 450 }
	}))

	const bind = useDrag(({ offset: [x, y], down, active }) => {
		onUseDrag(active)

		//const value = x / 1000
		const value = Math.min(Math.max(x / 1000, SLIDER_MIN), SLIDER_MAX)
		set({
			immediate: down,
			position: [value, 0.01, 0]
		})
		setAbsoluteValue(value)
	})

	return (
		<group ref={group} {...props} dispose={null}>
			<a.mesh
				geometry={nodes.Slider.geometry}
				material={nodes.Slider.material}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.01}
				receiveShadow
				castShadow
				{...spring}
				{...bind()}>
				<meshStandardMaterial
					attach="material"
					color={isSelected ? '#646464' : MATERIAL_COLOR}
				/>
			</a.mesh>
			<mesh
				geometry={nodes.Base.geometry}
				material={nodes.Base.material}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.01}
				receiveShadow
				castShadow
				onPointerOver={(e) => setBaseHover(true)}
				onPointerOut={(e) => setBaseHover(false)}
				onClick={() => onSelect()}>
				<meshStandardMaterial
					attach="material"
					color={
						enableSelection
							? isSelected
								? PLANE_COLOR
								: baseHover
								? HOVER_COLOR
								: PLANE_COLOR
							: PLANE_COLOR
					}
				/>
			</mesh>
			{showHhtml && (
				<Html
					position={[1.6, 0.4, 0]}
					rotation-x={Math.PI * -0.5}
					// rotation-y={Math.PI * 1}
					transform
					occlude>
					<div>{absoluteValue}</div>
				</Html>
			)}
		</group>
	)
}

useGLTF.preload('/Slider_TP1.gltf')
